import styled from "styled-components";
import { Link } from "react-router-dom";

// Utils
import { media } from "utils/media";

// Components
import { Input, Button } from "components/spocketUI/";

export const Page = styled.main`
  background-color: #f4f5f8 !important;
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 100%;
  width: 360px;
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  padding-bottom: 24px;
  margin-bottom: 40px;
  box-sizing: border-box;
`;

export const Logo = styled.img.attrs({ alt: "Spocket logo" })`
  height: 40px;
  margin-bottom: 20px;
`;

export const Form = styled.form`
  width: 100%;
`;

export const StyledInput = styled(Input)`
  height: 38px;
  background: ${props => props.theme.colors.white.colorWhite};
  margin-bottom: 10px;
  padding: 0 12px;
  box-sizing: border-box;
  font-family: inherit;
  color: inherit;
  font-size: inherit;
  line-height: inherit;
`;

export const StyledButton = styled(Button)`
  cursor: pointer;
  background-color: #774edd;
  color: #fff;
  border: none;
  font-weight: 500;
  width: 100%;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857;
  border-radius: 2px;
  box-shadow: 0 2px 2px 0 hsla(0, 0%, 60%, 0.14), 0 3px 1px -2px hsla(0, 0%, 60%, 0.2),
    0 1px 5px 0 hsla(0, 0%, 60%, 0.12);
  margin-bottom: 10px;
`;

export const ErrorText = styled.p`
  text-align: center;
  display: block;
  margin-top: -5px;
  margin-bottom: 10px;
  color: #e83339;
  font-weight: 500;
`;

export const ForgotPasswordButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  outline: inherit;
  color: #337ab7;
  font-weight: 500;
  text-decoration: none;
  &:hover {
    color: #23527c;
    text-decoration: underline;
  }
`;

export const SocialButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 25px;
  gap: 15px;
  width: 100%;
`;

export const SignupLinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  ${media.PHONE`
    flex-direction: column;
  `};
`;

export const LinkText = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 700;
`;

export const StyledLink = styled(Link)`
  color: #337ab7;
  text-decoration: none;
  font-weight: 700;
  &:hover {
    color: #23527c;
    text-decoration: underline;
  }
`;

export const AuthErrorText = styled.p`
  background-color: #f55a4e;
  color: #fff;
  border-radius: 3px;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(244, 67, 54, 0.4);
  padding: 15px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
`;
